import React from 'react';

import styled from 'styled-components';

import ShopNotesItem from './ShopNotesItem';
import { ShopNotesType } from '../types';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 15px 0;
`;

interface Props {
  data: ShopNotesType[];
}

const ShopNotesContent = ({ data }: Props) => (
  <Container>
    {data.map((item: ShopNotesType) => (
      <ShopNotesItem shopNote={item} key={item.id} />
    ))}
  </Container>
);

export default ShopNotesContent;
